import type { ReactNode } from 'react';

export const symbol_file_map_stack: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-200q-24 0-42-18t-18-42v-560q0-24 18-42t42-18h560q24 0 42 18t18 42v560q0 24-18 42t-42 18H260Zm0-60h560v-560H260v560ZM140-80q-24 0-42-18t-18-42v-590q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v590h590q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q742.75-80 730-80H140Zm120-740v560-560Zm249 267q-13-13-13-31t13-31q13-13 31-13t31 13q13 13 13 31t-13 31q-13 13-31 13t-31-13Zm31 233q89-75 132.5-139.79Q716-524.57 716-579.94q0-83.06-53.28-131.56-53.29-48.5-122.5-48.5-69.22 0-122.72 48.5T364-579.94q0 55.37 43.5 120.15Q451-395 540-320Z"
		/>
	</svg>
);
